export const PRICING_TIERS_REQUEST = 'PricingTiersRequest';
export const PRICING_TIERS_FAILURE = 'PricingTiersFailure';
export const PRICING_TIERS_SUCCESS = 'PricingTiersSuccess';

export const COUPON_REQUEST = 'CouponRequest';
export const COUPON_SUCCESS = 'CouponSuccess';
export const COUPON_FAILURE = 'CouponFailure';

export const TIP_PRODUCT_SUCCESS = 'TipProductSuccess';
export const TIP_PRODUCT_REQUEST = 'TipProductRequest';
export const TIP_PRODUCT_FAILURE = 'TipProductFailure';
